/**
 * Legacy Press enhancements
 *
 * Post types still rendering the legacy mettel design (see
 * functions/legacy-styles.php) get their markup and CSS from that theme, but
 * not its JavaScript bundle. This supplies the one piece of that bundle the
 * page visibly depends on: Select2 on the newsletter form's two dropdowns.
 *
 * Without it those selects render unstyled, because the legacy stylesheet
 * deliberately makes the native select invisible and styles the Select2 widget
 * that replaces it.
 *
 * The Select2 stylesheet is already present — it is part of the scoped legacy
 * stylesheet built by build-legacy-press-css.js.
 *
 * @package Embark
 * @since   1.0.0
 */

import $ from 'jquery';

// Imported for its side effect: it registers `$.fn.select2` on the jQuery
// instance resolved by the `jquery` webpack external.
import 'select2';

/**
 * Dropdowns enhanced on the legacy site, with the options it uses.
 *
 * Placeholders are hard-coded rather than read from the field, matching the
 * legacy bundle.
 */
const DROPDOWNS = [
	{
		selector: '.gform_wrapper .companytype select',
		placeholder: 'Company Type*',
	},
	{
		selector: '.gform_wrapper .howdidyou select',
		placeholder: 'How Did You Hear About Us?*',
	},
];

// `jquery` is a webpack external mapped to the global jQuery, so this is the
// same instance Gravity Forms uses — Select2 requires that.
if ($) {
	/**
	 * Shows the free-text "Other" field only when "Other" is selected.
	 *
	 * Mirrors the legacy bundle's change handler.
	 */
	const toggleOtherField = (value) => {
		const $other = $('.howdidyouother');

		if (!$other.length) {
			return;
		}

		if (value === 'Other') {
			$other.show();
			$other.find('input').removeAttr('disabled');
		} else {
			$other.hide();
			$other.find('input').prop('disabled', true);
		}
	};

	const enhance = () => {
		DROPDOWNS.forEach(({ selector, placeholder }) => {
			const $select = $(selector);

			if (!$select.length || $select.hasClass('select2-hidden-accessible')) {
				return;
			}

			// Select2 appends the dropdown panel to <body> by default, which
			// would put it outside `.legacy-press` — where the scoped legacy
			// stylesheet cannot reach it, leaving the panel unstyled. Render it
			// inside the wrapper instead. On the legacy site the whole page is
			// legacy, so <body> was always in scope there.
			const $wrapper = $select.closest('.legacy-press');

			$select.select2({
				minimumResultsForSearch: 0,
				placeholder,
				dropdownParent: $wrapper.length ? $wrapper : $(document.body),
			});
		});

		$('.gform_wrapper .howdidyou select')
			.off('change.emLegacyPress')
			.on('change.emLegacyPress', function () {
				toggleOtherField($(this).val());
			});
	};

	$(enhance);

	// Gravity Forms rebuilds the form markup after an ajax submission or when
	// conditional logic fires, which discards the widgets.
	$(document).on('gform_post_render', enhance);
}
